import { useEffect } from "react";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import { Nav } from "./components/site/Nav";
import { Hero } from "./components/site/Hero";
import { Marquee } from "./components/site/Marquee";
import { Approach } from "./components/site/Approach";
import { Services } from "./components/site/Services";
import { Framework } from "./components/site/Framework";
import { Pillars } from "./components/site/Pillars";
import { Vision } from "./components/site/Vision";
import { Appointment } from "./components/site/Appointment";
import { Contact } from "./components/site/Contact";
import { Footer } from "./components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <div className="App bg-[#F6F4EE] text-[#0B2B26]">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Approach />
        <Services />
        <Framework />
        <Pillars />
        <Vision />
        <Appointment />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
